import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Award, ArrowRight } from 'lucide-react';
import { useFinances } from '../hooks/useFinances';
import FinancialReports from '../components/FinancialReports';

export default function FinancesPage() {
  const { activeBusiness, stats } = useFinances();
  const navigate = useNavigate();

  if (!activeBusiness || !stats) return <div>Cargando...</div>;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-extrabold text-seryi-heading">Dashboard Financiero y Reportes de Caja</h2>
        <p className="text-xs text-seryi-text">Lleva el control de ingresos totales ingresados a caja por citas y pedidos pagados por WhatsApp.</p>
      </div>

      {/* Métricas Generales */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="bg-seryi-bg border border-seryi-bg-light p-6 rounded-2xl space-y-2">
          <span className="text-[10px] uppercase font-bold text-seryi-text tracking-wider">Ingresos Totales (Pagados)</span>
          <p className="text-3xl font-black text-emerald-400">${stats.totalPaid.toLocaleString('es-CO')}</p>
          <div className="text-[10px] text-emerald-400 font-bold flex items-center gap-1">
            Citas (${stats.displayApptsPaid.toLocaleString('es-CO')}) + Pedidos (${stats.displayOrdersPaid.toLocaleString('es-CO')})
          </div>
        </div>

        <div className="bg-seryi-bg border border-seryi-bg-light p-6 rounded-2xl space-y-2">
          <span className="text-[10px] uppercase font-bold text-seryi-text tracking-wider">Pendientes por Cobrar / Entregar</span>
          <p className="text-3xl font-black text-amber-400">${stats.totalPending.toLocaleString('es-CO')}</p>
          <div className="text-[10px] text-amber-400 font-bold">Órdenes y Citas en proceso</div>
        </div>
      </div>

      {/* Desglose por Empleado */}
      {(!activeBusiness.feature_commissions) ? (
        <div className="bg-seryi-bg border border-seryi-bg-light p-8 rounded-3xl space-y-4 max-w-4xl text-center">
          <div className="mx-auto w-16 h-16 bg-seryi-green/10 flex justify-center items-center rounded-full mb-2">
            <Sparkles size={32} className="text-seryi-green" />
          </div>
          <h3 className="font-bold text-lg text-seryi-heading">Módulo de Comisiones Bloqueado</h3>
          <p className="text-sm text-seryi-text max-w-md mx-auto">
            El cálculo automático de comisiones está deshabilitado en tu cuenta actual. Contacta a soporte para activar esta funcionalidad.
          </p>
          <a 
            href="https://wa.me/573174701590?text=Hola,%20quiero%20activar%20el%20m%C3%B3dulo%20de%20comisiones%20en%20Keyla%20CRM"
            target="_blank" rel="noopener noreferrer"
            className="mt-4 inline-block px-6 py-2 rounded-xl bg-seryi-green text-seryi-bg-dark font-bold text-sm"
          >
            Contactar Soporte
          </a>
        </div>
      ) : (
        <div className="bg-gradient-to-r from-seryi-bg to-seryi-bg-dark border border-seryi-bg-light p-6 rounded-3xl flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 max-w-4xl shadow-lg">
          <div>
            <h3 className="font-extrabold text-base text-seryi-heading flex items-center gap-2">
              <Award size={18} className="text-seryi-green" />
              <span>Módulo de Comisiones y Nómina del Equipo</span>
            </h3>
            <p className="text-xs text-seryi-text mt-1">
              Gestiona el desglose de pagos por especialista, ajusta acuerdos comerciales y exporta reportes.
            </p>
          </div>
          <button
            onClick={() => navigate('/v2/comisiones')}
            className="px-5 py-2.5 bg-seryi-green text-seryi-bg-dark hover:brightness-110 rounded-2xl text-xs font-bold transition-all shadow-md shrink-0 flex items-center gap-2"
          >
            <span>Abrir Nómina y Comisiones</span>
            <ArrowRight size={14} />
          </button>
        </div>
      )}

      {/* Libro de Movimientos Contables y Exportación CSV */}
      <FinancialReports activeBusiness={activeBusiness} />
    </div>
  );
}
